import { createReducer, on } from '@ngrx/store';

import { ITaxCertificateType } from '../models/tax-certificate-type.model';
import * as actions from '../actions';

export const taxCertificateTypeFeatureKey = 'taxCertificateType';

export interface State {
  taxCertificateType: ITaxCertificateType[];
  loaded: boolean;
  error?: Error | any;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  taxCertificateType: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    actions.loadGetTaxCertTypes,

    state => state
  ),
  on(actions.loadGetTaxCertTypesSuccess, (state, action) => ({
    ...state,
    taxCertificateType: action.response,
    loaded: true
  })),

  on(actions.loadGetTaxCertTypesFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectTaxCertificateType = (state: State) => state.taxCertificateType;
export const selectTaxCertificateTypeLoaded = (state: State) => state.loaded;
export const selectTaxCertificateTypeError = (state: State) => state.error;
